import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React from "react";
import { css } from "styled-components";

export interface ProductListFitmentsContainerStyles {
    fitmentsGridItem?: GridItemProps;
    fitmentsWrapper?: InjectableCss;
    img?: ImgProps;
    fitmentTitle?: TypographyPresentationProps;
    fitmentDescription?: TypographyPresentationProps;
}

export const productListFitmentsContainerStyles: ProductListFitmentsContainerStyles = {
    fitmentsGridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            flex-direction: column;
            padding: 10px 0;
        `,
    },
    fitmentsWrapper: {
        css: css`
            width: 100%;
            height: 100%;
            padding: 15px;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        { values: ["0", null, `1px solid ${COLORS.border.base}`, null, null], properties: ["border"] },
                        {
                            values: [`1px solid ${COLORS.border.base}`, null, null, null, null],
                            properties: ["border-bottom"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    img: {
        css: css`
            width: 100%;
            max-width: 250px;
        `,
    },
    fitmentTitle: {
        variant: "h2",
        size: TYPOGRAPHY.size.larger,
    },
    fitmentDescription: {
        color: COLORS.primary.base,
        weight: TYPOGRAPHY.weight.bold,
    },
};

const ProductListFitments = () => {
    const styles = productListFitmentsContainerStyles;

    return (
        <GridItem {...styles.fitmentsGridItem}>
            <StyledWrapper {...styles.fitmentsWrapper}>
                <Img src="userfiles/Fitment.jpg" loading="lazy" altText={translate("Fitment")} {...styles.img} />
                <Typography {...styles.fitmentTitle}>{translate("Call RSSW for fitment test")}</Typography>
                <Typography {...styles.fitmentDescription}>{translate("Contact RSSW at 1-866-866-8133")}</Typography>
            </StyledWrapper>
        </GridItem>
    );
};

export default ProductListFitments;
